module.exports = __webpack_public_path__ + "img/icon31.a1b4604f.png";